<template>
  <SlideYUpTransition :duration="animationDuration">
    <div ref="dialog"
         v-bind="$attrs"
         class="modal fade"
         @click.self="requestClose"
         @keydown.esc.stop="requestClose"
         @keydown.tab="trapFocus"
         :class="[{'show d-block': show}, {'d-none': !show}, {'modal-mini': type === 'mini'}]"
         v-show="show"
         tabindex="-1"
         role="dialog"
         :aria-modal="show ? 'true' : null"
         :aria-hidden="!show">

      <div class="modal-dialog"
           :class="[{'modal-notice': type === 'notice'}, modalClasses]">
        <div class="modal-content">

          <div class="modal-header" :class="headerClasses" v-if="showHeader">
            <slot name="close-button">
              <button type="button"
                      v-if="showClose"
                      @click="closeModal"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Fermer"
                      :aria-hidden="!show">
                <i class="now-ui-icons ui-1_simple-remove" aria-hidden="true"></i>
              </button>
            </slot>
            <slot name="header"></slot>
          </div>

          <div class="modal-body" :class="bodyClasses">
            <slot></slot>
          </div>

          <div class="modal-footer" :class="footerClasses" v-if="showFooter && $slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>

    </div>
  </SlideYUpTransition>
</template>
<script>
import { SlideYUpTransition } from 'vue2-transitions';

export default {
  name: 'modal',
  inheritAttrs: false,
  components: {
    SlideYUpTransition
  },
  props: {
    show: Boolean,
    showHeader: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: '',
      validator(value) {
        let acceptedValues = ['', 'notice', 'mini'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    modalClasses: [Object, String],
    headerClasses: [Object, String],
    bodyClasses: [Object, String],
    footerClasses: [Object, String],
    animationDuration: {
      type: Number,
      default: 500
    }
  },
  methods: {
    requestClose() {
      if (this.showClose) this.closeModal();
    },
    closeModal() {
      this.$emit('update:show', false);
      this.$emit('close');
    },
    focusDialog() {
      const dialog = this.$refs.dialog;
      if (!dialog) return;

      const target = dialog.querySelector(
        '[autofocus], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      (target || dialog).focus();
    },
    trapFocus(event) {
      const dialog = this.$refs.dialog;
      if (!dialog) return;

      const focusable = Array.from(dialog.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
      )).filter(element => element.offsetParent !== null);

      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  },
  data() {
    return {
      previouslyFocusedElement: null
    };
  },
  watch: {
    show(val) {
      let documentClasses = document.body.classList;
      if (val) {
        documentClasses.add('modal-open');
        this.previouslyFocusedElement = document.activeElement;
        this.$nextTick(this.focusDialog);
      } else {
        documentClasses.remove('modal-open');
        if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
          this.previouslyFocusedElement.focus();
        }
        this.previouslyFocusedElement = null;
      }
    }
  },
  beforeDestroy() {
    document.body.classList.remove('modal-open');
  }
};
</script>
<style>
.modal.show {
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
